import axiosInstance from 'src/utils/axios';
import * as Types from './types.api';

//

const BASE_URL = 'pdf-certificate';

//

export const getBusinessCertificateAPI = async (query: Types.PurchaseReceiptQuery) => {
  const { id } = query;

  const response = await axiosInstance.get(`${BASE_URL}/business/${id}`, {
    responseType: 'blob',
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const getCustomerCertificateAPI = async (query: Types.PurchaseReceiptQuery) => {
  const { id } = query;

  const response = await axiosInstance.get(`${BASE_URL}/customer/${id}`, {
    responseType: 'blob',
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const getReceiptAPI = async (query: Types.PurchaseReceiptQuery) => {
  const { id } = query;

  const response = await axiosInstance.get(`${BASE_URL}/business/${id}/receipt`, {
    responseType: 'blob',
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const getFootprintProposalAPI = async (query: Types.FootprintProposalQuery) => {
  const { footprintId } = query;

  const response = await axiosInstance.get(`${BASE_URL}/footprint-proposal/${footprintId}`, {
    responseType: 'blob',
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
